import MuiBox, { type BoxProps as MuiProps } from "@mui/material/Box";

export type BoxProps = MuiProps;

Box.Column = (props: MuiProps) => <MuiBox display="flex" flexDirection="column" {...props} />;

export default function Box(props: MuiProps) {
	return <MuiBox display="flex" {...props} />;
}